import {Box, Flex} from '@chakra-ui/react'
import Footer from './components/Footer'
import Header from './components/Header'
import {useEffect, useRef, useState} from 'react'
import Example from './components/Example'
import {useDispatch, useSelector} from 'react-redux'
import PickSentence from './PickSentence'
import YourSentence from './YourSentence'
import {paraphraseRequest} from '@apis/paraphrase'
import {reset, updateIsFirstTime} from '@redux/paraphrase/paraphraseSlice'
import DragDrop from './DragDrop'
import Pronuciation from './Pronuciation'
import Summary from './Summary'
import SelectAnswer from './SelectAnswer'
import FormReportError from '@components/FormReportError'
import {FEATURE_REPORT_ERROR, SCREEN_REPORT_ERROR} from '@utils/Const'
import ModalVerifyClose from '@pages/ConverstationPage/components/ModalVerifyClose'

export enum ParaphraseType {
  ENTER_SENTENCE = 'ENTER_SENTENCE',
  SHOW_SENTENCE = 'SHOW_SENTENCE',
  FIND_SYNONYM = 'FIND_SYNONYM',
  SELECT_ANSWER = 'SELECT_ANSWER',
  PRACTICE_SPEAKING = 'PRACTICE_SPEAKING',
  SUMMARY = 'SUMMARY',
}

export enum ParaphraseProgressEnum {
  ENTER_SENTENCE = 'nhập câu',
  FIND_SYNONYM = 'tìm từ đồng nghĩa',
  SELECT_ANSWER = 'chọn đáp án',
  PRACTICE_SPEAKING = 'luyện nói',
}

export const paraphraseProgress = [
  ParaphraseProgressEnum.ENTER_SENTENCE,
  ParaphraseProgressEnum.FIND_SYNONYM,
  ParaphraseProgressEnum.SELECT_ANSWER,
  ParaphraseProgressEnum.PRACTICE_SPEAKING,
]

export const paraphraseColors = [
  {
    color: '#FA8C16',
    bg: '#FFF9ED',
  },
  {
    color: '#339CFF',
    bg: 'EEF8FF',
  },
  {
    color: '#00C7BE',
    bg: '#EAFFFE',
  },
  {
    color: '#FF45BB',
    bg: '#F9E4FF',
  },
  {
    color: '#5856D6',
    bg: '#ECECFF',
  },
]

const ParaphrasePage = () => {
  const {progress, currentProgress, type, audio} = useSelector(
    (state: any) => state.paraphrase,
  )
  const [isShowExample, setIsShowExample] = useState(true)
  const dispatch = useDispatch()
  const audioRef = useRef<HTMLAudioElement>(null)

  useEffect(() => {
    const getStatus = async () => {
      const res = await paraphraseRequest.getStatus()
      dispatch(updateIsFirstTime(res?.data?.data?.is_first_time))
    }
    getStatus()

    return () => {
      dispatch(reset())
    }
  }, [])

  useEffect(() => {
    if (!audio?.url || !audioRef.current) return

    let isSubscribed = true

    const playAudio = async () => {
      try {
        if (!isSubscribed) return

        if (audioRef.current) {
          audioRef.current.pause()
          audioRef.current.currentTime = 0
          audioRef.current.src = audio?.url

          await audioRef.current.load()

          // Set playbackRate sau khi đã load audio
          audioRef.current.playbackRate = audio?.speed || 1

          if (isSubscribed && audioRef.current) {
            await audioRef.current.play()
          }
        }
      } catch (error) {
        console.error('Error playing audio:', error)
      }
    }

    playAudio()

    return () => {
      isSubscribed = false
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current.src = ''
      }
    }
  }, [audio?.time])

  const renderContent = () => {
    switch (type) {
      case ParaphraseType.ENTER_SENTENCE:
        return <PickSentence />
      case ParaphraseType.SHOW_SENTENCE:
        return <YourSentence />
      case ParaphraseType.FIND_SYNONYM:
        return <DragDrop />
      case ParaphraseType.SELECT_ANSWER:
        return <SelectAnswer />
      case ParaphraseType.PRACTICE_SPEAKING:
        return <Pronuciation />
      case ParaphraseType.SUMMARY:
        return <Summary />
      default:
        return <>Not found</>
    }
  }

  return (
    <Flex className="paraphrase-page" h={'100dvh'} flexDirection={'column'}>
      {isShowExample ? (
        <Example setIsShowExample={setIsShowExample} />
      ) : (
        <>
          <Flex
            flex={1}
            overflow={'auto'}
            flexDirection={'column'}
            p={{base: '16px', md: '32px'}}>
            <Header
              steps={progress}
              currentContent={{progress: currentProgress}}
            />
            <Box
              flex={1}
              overflow={'auto'}
              className="paraphrase-content"
              mt={'32px'}
              w={'100%'}
              maxW={'1280px'}
              mx={'auto'}>
              {renderContent()}
            </Box>
          </Flex>
          <Footer />
        </>
      )}
      <FormReportError
        feature={FEATURE_REPORT_ERROR.LESSON_PART_2}
        screen={SCREEN_REPORT_ERROR.LESSON_PART_2}
      />
      <ModalVerifyClose />
      <audio ref={audioRef} style={{display: 'none'}}>
        Trình duyệt của bạn không hỗ trợ thẻ audio.
      </audio>
    </Flex>
  )
}

export default ParaphrasePage
